<div class="flex justify-between mb-4">
  <div class="text-xl text-gray-700 font-bold">Acompanhamento de OS</div>
  <!--  @if (checkPermission('criar')) {-->
  <!--  }-->
</div>
<div>
  <app-monitoring-search (response)="listSearch($event)" (loadingList)="loading"></app-monitoring-search>
</div>

<div>
  <div class="mt-4">
    <!--    @if (checkPermission('pesquisar-paginado')) {-->
    <!--    <form-search [search]="inputSearch" (responseSearch)="search($event)" />-->
    <!--    <form-client-search-->
    <!--      [search]="inputSearch"-->
    <!--      [listSearch]="listSearch"-->
    <!--      (responseSearch)="search($event)"-->
    <!--    />-->
    <!--    }-->
    <div class="mb-3">
      @if (!selectionMode) {
        <button mat-flat-button class="btn-tg" (click)="startSelection()">
          Selecionar OS(s) — fila do operador
        </button>
      } @else {
        <div class="flex gap-2">
          <button mat-flat-button class="btn-tg-white" (click)="cancelSelection()">Cancelar</button>
          <button mat-flat-button class="btn-tg" (click)="confirmarSelecionadas()">
            Confirmar ({{ selectedOsIds.length }})
          </button>
          <button mat-flat-button class="btn-tg" (click)="recusarSelecionadas()">
            Recusar ({{ selectedOsIds.length }})
          </button>
        </div>
      }
    </div>
    <div>
      @if (!loading) {
      @if (itemsList.length > 0) {
      <div class="tab-overflow overflow-auto w-[100%]">
        <table-list-monitoring [dataSource]="itemsList" [columns]="columns" [selectedIds]="selectedOsIds"
          (viewItem)="viewItem($event)"
          (confirmarOperadorItem)="confirmarOperadorItem($event)" (recusarOperadorItem)="recusarOperadorItem($event)"
          (toggleSelectItem)="toggleSelectItem($event)" (toggleSelectAll)="toggleSelectAllItems($event)"
          (viewPassengersItem)="viewPassengers($event)"
          (assignDriverItem)="assignDriver($event)" (assignVehicleItem)="assignVehicle($event)" sticky />
      </div>

      } @else {
      <div>
        <h3 class="text-center">Nenhum registro encontrado.</h3>
      </div>
      }
      } @else {

      <mat-progress-bar mode="indeterminate"></mat-progress-bar>

      }
      <mat-paginator [hidden]="itemsList.length == 0 || loading" [length]="numberRows" [pageSize]="rows"
        [pageIndex]="page - 1" [pageSizeOptions]="[5, 10, 20, 30]" (page)="onPageEvent($event)">
      </mat-paginator>
    </div>
  </div>
</div>